import React from "react";
import "@/App.css";
import "./styles/theme.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import ElLibro from "./pages/ElLibro";
import Tiane from "./pages/Tiane";
import Logros from "./pages/Logros";
import Comprar from "./pages/Comprar";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/libro" element={<ElLibro />} />
          <Route path="/tiane" element={<Tiane />} />
          <Route path="/logros" element={<Logros />} />
          <Route path="/comprar" element={<Comprar />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
